





























import { auth } from "@/scripts/firebase";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { goOffline } from "@/utils/auth";

@Component
export default class Header extends Vue {
  isActive = false;

  get hasUser(): boolean {
    return !!this.$store.state.firebaseUser;
  }
  handleSignOut() {
    auth.signOut();
    const uid = this.$store.state.firebaseUser.uid;
    this.$store.commit("setUser", null);
    this.$store.commit("setFirebaseUser", null);
    goOffline(uid);
    this.isActive = false;
  }

  get headerTitle(): string {
    const title = "人狼GM代行こゆき.app";
    if (process.env.NODE_ENV === "production") {
      return title;
    }
    if (process.env.NODE_ENV === "staging") {
      return title + " [Staging]";
    } else {
      return title + " [Development]";
    }
  }

  get authLink(): string {
    const defaultPath = "/auth";
    const path =
      this.$route.path !== "/"
        ? defaultPath + "?from=" + this.$route.path
        : defaultPath;
    return path;
  }
}
